/** Doctor web build: no Electron; keeps same API as main app for shared Login.jsx */
export function isElectron() {
  return typeof window !== "undefined" && window.electronAPI && window.electronAPI.isElectron;
}
